import React from "react";
import { Link } from "react-router-dom";
import { PageMeta } from "@/components/PageMeta";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CtaBand } from "@/components/CtaBand";
import { BRAND, IMAGES } from "@/config/brand";
import { ArrowRight } from "lucide-react";

export const POSTS = [
    { slug: "moving-house-checklist", title: "Moving House Checklist", excerpt: "A week-by-week timeline to stay organised in the run-up to moving day." },
    { slug: "how-to-prepare-for-moving-day", title: "How to Prepare for Moving Day", excerpt: "Small steps that save hours and stress on the day itself." },
    { slug: "how-to-pack-fragile-items", title: "How to Pack Fragile Items", excerpt: "Techniques for glassware, ceramics and electronics." },
    { slug: "how-much-do-london-removals-cost", title: "How Much Do London Removals Cost?", excerpt: "What actually drives the price of your move — and how to keep it fair." },
    { slug: "parking-and-access-for-a-london-move", title: "Parking and Access for a London Move", excerpt: "Reserving space, permits and what to check before the day." },
    { slug: "questions-to-ask-a-removals-company", title: "Questions to Ask a Removals Company", excerpt: "Ten questions that separate careful movers from cowboys." },
];

export default function MovingTips() {
    return (
        <div>
            <PageMeta title="Moving Tips — YS Removals" description="Practical moving guides from YS Removals — checklists, packing advice and how to plan a London move." canonical={`https://${BRAND.domain}/moving-tips`} />
            <section className="bg-[#001B3D] text-white">
                <div className="container-ys section">
                    <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Moving Tips" }]} />
                    <h1 className="mt-3 text-4xl sm:text-5xl font-semibold tracking-tight font-heading">Moving tips</h1>
                    <p className="mt-3 text-white/85 max-w-2xl">Straightforward guides to help you plan and enjoy a calmer move.</p>
                </div>
            </section>
            <section className="container-ys section grid gap-6 md:grid-cols-3">
                {POSTS.map((p, i) => (
                    <Link key={p.slug} to={`/moving-tips/${p.slug}`} className="group rounded-2xl overflow-hidden bg-white border border-[#17252D]/10 hover:border-[#001B3D]/40 transition-[border-color] duration-200">
                        <div className="aspect-[16/9] overflow-hidden">
                            <img src={i % 2 === 0 ? IMAGES.blog1 : IMAGES.blog2} alt="" loading="lazy" className="h-full w-full object-cover" />
                        </div>
                        <div className="p-4">
                            <div className="font-heading font-semibold">{p.title}</div>
                            <p className="mt-1 text-sm text-[#17252D]/75">{p.excerpt}</p>
                            <span className="mt-3 inline-flex items-center gap-1 text-sm text-[#001B3D]">Read guide <ArrowRight className="h-4 w-4" /></span>
                        </div>
                    </Link>
                ))}
            </section>
            <CtaBand />
        </div>
    );
}
